import { Button, ButtonProps } from '@mui/material'
import { styled } from '@mui/material/styles'

export interface SelectButtonProps extends ButtonProps {
  isSelected?: boolean
}

export const SelectButton = styled(Button, {
  shouldForwardProp: prop => prop !== 'isSelected',
})<SelectButtonProps>(({ theme, isSelected }) => ({
  marginRight: theme.spacing(1),
  marginBottom: theme.spacing(1),
  paddingLeft: theme.spacing(2),
  paddingRight: theme.spacing(2),
  color: isSelected ? theme.palette.text.primary : 'inherit',
  border: `1px solid`,
  borderColor: isSelected ? theme.palette.success.dark : theme.palette.divider,
  backgroundColor: isSelected ? theme.palette.success.light : 'transparent',
  position: 'relative',
  borderRadius: theme.spacing(12.5),
  transition: 'all 0.2s ease-in-out',
  '&::before': {
    content: '""',
    position: 'absolute',
    top: theme.spacing(-0.5),
    left: theme.spacing(-0.5),
    right: theme.spacing(-0.5),
    bottom: theme.spacing(-0.5),
    border: `2px solid transparent`,
    borderRadius: theme.spacing(12.5),
    transition: 'all 0.2s ease-in-out',
  },
  '&:focus': {
    '&::before': {
      borderColor: theme.palette.common.black,
    },
  },
  '&:hover': {
    backgroundColor: isSelected ? theme.palette.success.light : theme.palette.action.hover,
    borderColor: theme.palette.primary.main + '80',
  },
}))
